// utils
import { createAction } from 'redux-actions'

export const setAuthenticationState = createAction('AUTHENTICATION_STATE_SET')
export const setReloadPage = createAction('SET_RELOAD_PAGE')
export const setIsUrgentCareUser = createAction('SET_IS_URGENT_CARE_USER')
export const setRibbonTimestamp = createAction('SET_RIBBON_TIMESTAMP')
export const getAuthToken = createAction('GET_AUTH_TOKEN')
export const setRememberPasswordExpiration = createAction(
  'SET_REMEMBER_PASSWORD_EXPIRATION'
)
export const setShouldShowPasswordExpired = createAction(
  'SET_SHOULD_SHOW_PASSWORD_EXPIRED'
)

export const setUserDataLoadedState = createAction('SET_USER_DATA_SET')
export const setUserActivitiesCounters = createAction(
  'SET_USER_ACTIVITIES_COUNTERS'
)
export const setUserLicenseModule = createAction('SET_USER_LICENSE_MODULE')
export const setUserProfile = createAction('USER_PROFILE_SET')
export const setUserRoles = createAction('SET_USER_ROLES')
export const setDefaultClinicianCalendar = createAction(
  'SET_DEFAULT_CLINICIAN_CALENDAR'
)
